import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-issue-material-modal',
  templateUrl: './issue-material-modal.component.html',
  styleUrls: ['../modal.component.scss']
})
export class IssueMaterialModalComponent {
  @Input() title: string;
  @Output() readonly responseChanged = new EventEmitter();

  form = {
    quantityIssued: 0,
    quantityReturned: 0
  };

  emitTrue(): void {
    this.responseChanged.emit(this.form);
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}
